import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import DataService from 'lib/DataService';

import Brochure from '../../Building/Brochures/Brochure';
import Loading from 'components/Loading';

import {
	OverflowContainer,
	Container,
} from './styles';

const Api = new DataService();

class CollectionBrochures extends React.Component {
	resetBrochuresHandler(brochures) {
		const { collection: { id, data } } = this.props;

		Api.updateCollection({
			id,
			brochures,
			data
		}).then(response => {
			if (response.result.collection) {
				this.props.collectionHandler(response.result.collection);
			}
		})
	}

	render() {
		const { t, users, collection } = this.props;
		const hasDeletedBrochures = collection && this.props.brochures.length < collection.brochures.length;
		const validBrochures = [];
		const brochures = this.props.brochures.map(brochure => {
			const author = users.find(user => user.email === brochure.author);

			validBrochures.push(brochure.id);

			brochure.authorName = '';

			if (typeof author !== 'undefined') {
				brochure.authorName = `${author.firstName} ${author.lastName}`;
			}

			return (
				<Brochure
					key={brochure.id}
					type="list"
					brochure={brochure}
					fromCollection={true}
					collection={collection.locked ? false : collection}
					collectionHandler={this.props.collectionHandler}
					brochureInCollection={true}
					baseUrl={this.props.baseUrl}
					canAddToCollection={true}
					canShare={false}
					canClone={false}
					canRemove={false}
					cloneBrochureHandler={() => {}}
					deleteBrochureHandler={() => {}}
				/>
			)
		});

		// Remove invalid brochure references
		if (!this.props.loading && hasDeletedBrochures) {
			//this.resetBrochuresHandler(validBrochures);
		}

		return (
			<OverflowContainer>
				<h2>{t('collection/Brochures')}</h2>
				<Container>
					{ this.props.loading ? <Loading /> : brochures }
				</Container>
			</OverflowContainer>
		);
	}
}

CollectionBrochures.propTypes = {
	t: PropTypes.func,
	loading: PropTypes.bool,
	baseUrl: PropTypes.string,
	collection: PropTypes.any,
	brochures: PropTypes.array,
	users: PropTypes.array,
	user: PropTypes.object,
	collectionHandler: PropTypes.func,
}

export default translate('translations')(CollectionBrochures)
